export const MaybeWrap = ({
  children,
  condition,
  wrapper,
}: {
  children: React.ReactNode;
  condition: boolean;
  wrapper: (children: React.ReactNode) => React.ReactNode;
}) => (condition ? wrapper(children) : children);
